import React from "react";

import { Box } from "@mui/material";
import MainHeader from "../../shared/MainHeader";

import PvtCaseOnHoldTable from "../../components/PvtCaseHoldTable";

const PvtcaseOnHold = () => {
  return (
    <Box>
      <MainHeader headingText={"Private Cases on Hold"} />

      <PvtCaseOnHoldTable />
    </Box>
  );
};

export default PvtcaseOnHold;
